import { forwardRef } from 'react'
import { Switch as AntSwitch, SwitchProps } from 'antd'
import cl from 'classnames'

import styles from './styles.module.scss'

const Switch = forwardRef<HTMLInputElement, SwitchProps>(
	({ className, checkedChildren, unCheckedChildren, checked, disabled, ...props }, ref) => (
		<AntSwitch
			{...props}
			className={cl(styles.basicSwitch, className, { [styles.checked]: checked })}
			checkedChildren={checkedChildren || <span>YES</span>}
			unCheckedChildren={unCheckedChildren || <span>NO</span>}
			ref={ref}
			checked={checked}
			disabled={disabled}
		/>
	)
)

export default Switch
